module.exports = __webpack_public_path__ + "img/word.ebd91361.svg";